import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";


export const GET_SYSTEM_PAYERS_MAPPING_LIST = "GET_SYSTEM_PAYERS_MAPPING_LIST";

export const service = async () => {
    const options: object = {
        url: `/Api/PayerGroup/GetSystemPayerMappingList`,
        method: 'GET',  
    }; 

    const response = callMvcApi(options);
    return response;
};

const mockData = () => {
    return [];
};

const mock = () => {
    const promise = new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(mockData());
        }, 2000);
    });
    return promise;
};

register(GET_SYSTEM_PAYERS_MAPPING_LIST, service, mock);